const getClientIp = async () => {
  return fetch("https://api.ipify.org?format=json")
    .then((response) => response.json())
    .then((data) => data.ip)
    .catch((error) => {
      console.error("Error fetching client IP:", error);
      return "";
    });
};

export default getClientIp;
